// XL Feet: show collection/search grids 12 cards at a time.
// The server still renders a deep page (36) with non-representative colorways
// already removed, so no product is ever lost — this only limits how many
// cards are visible (and how many images load) at once. A "Show more"
// button reveals the next 12 until the page is exhausted; the theme's own
// pagination then moves to the next server page.
(function () {
  var PAGE_SIZE = 12;
  var HIDDEN_CLASS = 'xlf-pager-hidden';
  var STYLE_ID = 'xlf-pager-style';

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '.' + HIDDEN_CLASS + '{display:none !important;}' +
      '.xlf-pager-btn{display:block;margin:2.5rem auto 1rem;padding:1.1rem 3rem;' +
      'background:#111;color:#fff;border:none;border-radius:3px;' +
      'font-size:1.5rem;letter-spacing:.02em;cursor:pointer;}' +
      '.xlf-pager-btn:hover{opacity:.85;}';
    document.head.appendChild(style);
  }

  function findGrid() {
    var container = document.getElementById('ProductGridContainer');
    if (!container) return null;
    var grid = container.querySelector('ul.product-grid');
    if (!grid || grid.classList.contains('slider')) return null;
    return grid;
  }

  function enhance() {
    var grid = findGrid();
    if (!grid || grid.getAttribute('data-xlf-pager') === 'done') return;
    var items = [];
    for (var i = 0; i < grid.children.length; i++) {
      if (grid.children[i].tagName === 'LI') items.push(grid.children[i]);
    }
    grid.setAttribute('data-xlf-pager', 'done');
    if (items.length <= PAGE_SIZE) return;

    var shown = PAGE_SIZE;
    items.forEach(function (el, idx) {
      if (idx >= PAGE_SIZE) el.classList.add(HIDDEN_CLASS);
    });

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'xlf-pager-btn';
    function label() {
      button.textContent =
        'Show more products (' + (items.length - shown) + ' more)';
    }
    label();
    button.addEventListener('click', function () {
      var next = Math.min(shown + PAGE_SIZE, items.length);
      for (var j = shown; j < next; j++) {
        items[j].classList.remove(HIDDEN_CLASS);
      }
      shown = next;
      if (shown >= items.length) {
        button.remove();
      } else {
        label();
      }
      window.dispatchEvent(new Event('resize'));
    });
    grid.parentNode.insertBefore(button, grid.nextSibling);
  }

  function init() {
    injectStyle();
    enhance();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Facet/filter re-renders swap the grid container's contents — re-apply
  // whenever a fresh, unprocessed grid shows up.
  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    setTimeout(function () {
      pending = false;
      init();
    }, 60);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
